<script>
import store from '../../store';
// import labelSelect from '../labelSelect';
import sidebar from './sidebar';
import transitionFade from '@/components/transition/fade.vue';
// const sidebar = () => import('./sidebar');
export default {
    data() {
        return {
            load: !window.__PRERENDER_INJECTED,
            status: false,
            isError: false,
            tip: ''
        }
    },
    computed: {
        listLength() {
            if(store.dealerInfoMsg) {
                this.isError = true;
                this.tip = store.dealerInfoMsg;
            } else {
                this.isError = false;
                this.tip = '请选择经销商';
            }
            return store.form.dealers.length || 0;
        }
    },
    components: {
        sidebar,
        // labelSelect,
        transitionFade
    },
    methods: {
        sidebarHandler() {
            this.status = true;
        },
        checkChange() {
            console.log('checkDealer');
            if (this.listLength === 0 || this.listLength > 3) {
                this.isError = true;
            } else{
                this.isError = false;
            } 
            return this.isError;
        },
        change() {
            this.checkChange();
        }
    }
}
</script>

<template>
    <div class="select-dealer">
        <div class="label-select" @click="sidebarHandler">
            <em>已选商家</em>
            <div class="value">已选{{listLength}}家</div>
            <img src="../../../assets/arrow-right.png" alt="">
        </div>
        <transition-fade>
            <p class="error" v-show="isError">{{ tip }}</p>
        </transition-fade>
        <sidebar v-if="load" :status="status" @update:status="status = $event" @change="change"></sidebar>
    </div>
</template>

<style lang="stylus" scoped>
.select-dealer
    .label-select
        position relative
        border-bottom 0.053rem solid #ebebeb
        em
            position absolute
            top 0
            bottom 0
            left 0
            margin auto
            height 1rem
            line-height 1rem
            font-size 0.85rem
            font-style normal
            color #333
        .value 
            padding 0.74rem 1rem 0.74rem 4.5rem
            width 100%
            height 2.48rem
            line-height 1rem
            border 0
            box-shadow none
            box-sizing border-box
            font-size 0.85rem
            color #333
            outline 0
        img
            position absolute
            top 0
            bottom 0
            right 0
            margin auto
    .error
        margin-top 0.2rem
        line-height 1.2
        font-size 0.64rem
        white-space nowrap
        color #f60
</style>